import axios from 'axios'
import store from '@/store'

axios.interceptors.request.use(config => {
  config.headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-header': '*'
  }
  if (store.state.login.token) {
    config.headers.authorization = `Bearer ${store.state.login.token}`
  }
  return config
}, err => {
  return Promise.reject(err)
})

export default axios
